module.exports = function() {
  return new Worker(__webpack_public_path__ + "9cdd930c7657e1c6b42a.worker.js");
};